module.exports = __webpack_public_path__ + "media/images/yogaplace2-1348ef9055bb2a9fb441b4f5de1515e0.png";